import React from 'react';
import { Box, styled } from '@mui/material';
//
import StepsNav from './StepsNav';
import { Logout } from '@components';

const SIDEBAR_WIDTH = 320;

const MuiSidebar = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  bottom: 0,
  width: SIDEBAR_WIDTH,
  display: 'flex',
  height: '100%',
  minHeight: '100vh',
  padding: theme.spacing(2),
  zIndex: 3,

  '& > .MuiBox-root': {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(5, 4),
    paddingRight: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
}));

const Sidebar: React.FC = () => {
  return (
    <MuiSidebar>
      <Box>
        <StepsNav />

        <Box mt={5}>
          <Logout />
        </Box>
      </Box>
    </MuiSidebar>
  );
};

export default Sidebar;
